var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 8.63643V12.4859H15.0007V14.4153H14.0013V15.3777H13.0019V16.3401H12.0024V17.3024H9.99895V18.2648H8.99953V19.2272H7.00068V20.1896H4.00241V21.1566H0.999512V20.1896H1.99894V19.2272H5.00183V18.2648H7.00068V17.3024H8.00011V16.3401H8.99953V15.3777H9.99895V14.4153H10.9984V8.63643H6.00126V7.67405H9.99895V6.71167H13.0019V7.67405H15.0007V8.63643H16.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0005 2.85764V4.7824H14.0011V5.7494H10.9982V4.7824H9.99878V2.85764H10.9982V1.89526H14.0011V2.85764H15.0005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99887 0.932861V1.89524H8.00002V2.85762H6.00117V3.82H5.00175V4.78237H4.00232V6.71175H2.99827V9.59888H4.00232V10.5613H8.00002V11.5236H6.00117V12.486H1.99885V11.5236H0V6.71175H0.999424V5.74938H1.99885V4.78237H2.99827V3.82H4.00232V2.85762H5.00175V1.89524H7.00059V0.932861H9.99887Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer_logo.f85cb30fe7393dffe87233e8356eec57.svg";
export { ForwardRef as ReactComponent };